<div *ngIf="!autoLogin && this.showLogin !== 2" dir="{{dir}}" class="login-wrapper">
	<div class="header" *ngIf="!embeddedLogin">
		<div class="header-cover"></div>
		<div class="header-content">
			<cp-site-icon [iconName]="'SITE_LOGO_BIG'"></cp-site-icon>
			<span class="title">{{headerTitle}}</span>
			<ng-container [ngSwitch]="this.themeService.currentTheme">
				<img  *ngSwitchCase="theme.light" [src]="resources.imgs.philipsLight" />
				<img *ngSwitchCase="theme.dark" [src]="resources.imgs.philipsDark" />
				<img *ngSwitchCase="theme.dynamic" [src]="resources.imgs.philipsLight" />
			</ng-container>
		</div>
	</div>
	<div class="browser-warning-message" *ngIf="showForm && !browserValidation">
		<i class="cp-icon-error"></i>
		<label> {{'UnsupportedBrowserWarning' | cpLabelTranslate}}</label>
		<span> {{'UnsupportedBrowserWarning' | cpMessageTranslate}}</span>
	</div>

	<div class="content">
		<div class="login-form-wrapper" [ngClass]="{'embedded': embeddedLogin}">
			<ng-container *ngIf="showForm; else spinner">
				<div class="title">{{'LogIn' | cpTitleTranslate}}</div>
				<form class="form-container" #f="ngForm" (ngSubmit)="disableLoginButton = true; login(f)" autocomplete="off" action="">
					<div class="label-wrapper">
						<label>{{'UserName' | cpLabelTranslate}}:</label>
						<i class="cp-icon-help hide-on-mobile"  title="{{'PleaseEnterUserNameHere' | cpMessageTranslate}}"></i>
					</div>
					<div class="input-wrapper">
						<input autofocus type="text" [ngModel]="userNameParam" name="userName" autocomplete="off" autocorrect="off" autocapitalize="off" placeholder="{{'PleaseEnterUserName' | cpLabelTranslate}}" />
					</div>

					<div class="label-wrapper">
						<label>{{'Password' | cpLabelTranslate}}:</label>
						<i class="cp-icon-help hide-on-mobile" title="{{'PleaseEnterPasswordHere' | cpMessageTranslate}}"></i>
					</div>
					<div class="input-wrapper">
						<input type="password" ngModel name="password" autocomplete="off" autocorrect="off" autocapitalize="off" placeholder="{{'PleaseEnterPassword' | cpLabelTranslate}}" />
					</div>

					<div class="label-wrapper">
						<label>{{'DirectoryServer' | cpLabelTranslate}}:</label>
						<i class="cp-icon-help hide-on-mobile" title="{{'PleaseSelectDirectoryServer' | cpMessageTranslate}}"></i>
					</div>

					<div class="directory-service-wrapper">
						<cp-directory-service-selection [autoLoginDirectory]="directoryServer" (selected)="setDirectory($event)"></cp-directory-service-selection>
					</div>

					<div class="status-wrapper" [ngClass]="statusFlag">
						<ng-container  *ngIf="statusFlag == 'invalid' || statusFlag == 'invalidNoTranslate'">
							<i class="cp-icon-error"></i>
							<div *ngIf="statusFlag == 'invalid'" class="status">{{status | cpMessageTranslate:{'a0': statusParam} }}</div>
							<div *ngIf="statusFlag == 'invalidNoTranslate'" class="status">{{status}}</div>
						</ng-container>
					</div>

					<div class="warning-message-wrapper" *ngIf="warningMessageEnabled === 'Y'" title={{warningMessage}}>
						{{warningMessage}}
					</div>

					<button type="submit" class="login-button" [disabled]="disableLoginButton">
						<i *ngIf="!browserValidation" class="cp-icon-error"></i>
						{{'LogInNow' | cpActionTranslate}}
					</button>

					<div class="change-password-wrapper">
						<label class="change-password-link" (click)="onPasswordChangeClick()">{{'ChangePassword' | cpActionTranslate}}</label>
					</div>

					<div *ngIf="statusFlag == 'inprog' || statusFlag == 'valid'" class="status-spinner">
						<div class="loading-image"></div>
					</div>

					<div class="build-date-wrapper" *ngIf="buildDate">
						<div class="build">{{'BuiltOn' | cpLabelTranslate}}: {{buildDate}}</div>
					</div>

					<div class="udi-wrapper">
						<div class="udi">
							<span>{{'Release' | cpLabelTranslate: {'a0': releaseVersion} }}</span>
							<span class="version-label">{{'Version' | cpLabelTranslate: {'a0': commercialVersion} }}</span>
						</div>
					</div>
				</form>
			</ng-container>

			<ng-template #spinner>
				<div class="spinner-container">
					<div class="loading-image"></div>
				</div>
			</ng-template>
		</div>

		<div class="main-image" [ngClass]="{'embedded': embeddedLogin}">
			<div class="main-image-cover"></div>
			<img [src]="resources.imgs.main" />
			<div *ngIf="showForm" class="main-image-title"><span>{{'PatientCare' | cpLabelTranslate}}</span></div>
		</div>
	</div>
	<div class="footer" *ngIf="!embeddedLogin" [ngClass]="{'unreleased': isUnreleasedDevice, 'released-medical': !isUnreleasedDevice && !isNonMedicalDevice}">
		<div class="left">
			<ng-container *ngIf="showForm" >
				<span class="about" (click)="showAbout=true"><u>{{'LoginFooterAbout' | cpLabelTranslate}}</u></span>
				<span>{{'Copyright' | cpLabelTranslate:{'a0': "© " + copyrightYear} }}</span>
				<span *ngIf="isNonMedicalDevice">{{'NonDiagnosticStatement' | cpLabelTranslate}}</span>
				<span *ngIf="isUnreleasedDevice">{{'WarrantyDisclaimer' | cpLabelTranslate:{'a0': 'Workflow Information Management', 'a1': releaseVersion} }}</span>
			</ng-container>
		</div>
		<div class="right">
			<ng-container [ngSwitch]="this.themeService.currentTheme">
				<img *ngSwitchCase="theme.light"  class="consult-symbol" [src]="resources.imgs.consultSymbolight" />
				<img *ngSwitchCase="theme.dark" class="consult-symbol" [src]="resources.imgs.consultSymbolDark" />
				<img *ngSwitchCase="theme.dynamic" class="consult-symbol" [src]="resources.imgs.consultSymbolight" />
			</ng-container>


			<a href="https://www.philips.com/IFU" target="_blank">eIFU</a>
			<ng-container [ngSwitch]="this.themeService.currentTheme">
				<img *ngSwitchCase="theme.light"  class="caution-symbol" [src]="resources.imgs.cautionSymbolLight" />
				<img *ngSwitchCase="theme.dark" class="caution-symbol" [src]="resources.imgs.cautionSymbolDark" />
				<img *ngSwitchCase="theme.dynamic" class="caution-symbol" [src]="resources.imgs.cautionSymbolLight" />
			</ng-container>

			<span *ngIf="showForm && isUnreleasedDevice"  class="caution-text" >{{'EvaluationPurposes' | cpLabelTranslate}}</span>
		</div>
	</div>
</div>

<div *ngIf="autoLogin && this.showLogin !== 2" class="loader-wrapper">
	<div class="loading-image"></div>
</div>

<div *ngIf="ignoreTimeZone === false && timeZoneValidation === false && translateLoaded" class="client-error timezone-error">
	{{'TimeZoneIncorrectWithServerTime' | cpMessageTranslate: {a0: serverTime} }}
</div>

<div *ngIf="licenseValidation === false && translateLoaded" class="client-error license-error">
	{{'LicenseMissing' | cpMessageTranslate}}
</div>

<cp-popup *ngIf="showChangePassword"
		  [width]="'310px'"
		  [label]="'ChangePassword'"
		  [draggable]="true"
		  [disposable]="false"
		  [contentPadding]="false"
		  [autoHeight]="true"
		  (close)="showChangePassword = false;">
	<cp-change-password [userPasswordPattern]="userPasswordPattern"
						[passwordMinLength]="passwordMinLength"
						[lockTimeInMinutes]="lockTimeInMinutes"
						(close)="showChangePassword = false;">
	</cp-change-password>
</cp-popup>
<ng-container *ngIf="showAbout">
	<cp-about (close)="showAbout=false;"></cp-about>
</ng-container>

<cp-otp-verification *ngIf="showVerificationCodeDialog" [ngClass]="{'embedded': embeddedLogin}"
					(close)="showVerificationCodeDialog=false; clearCredentials();"
					(codeVerified)="showVerificationCodeDialog=false; codeVerified($event)"
					(sessionExpired)="showSessionExpiredMessage=true"
					(initializeTOTP)="showVerificationCodeDialog=false;showTOTPInitializationDialog=true;">
</cp-otp-verification>

<cp-initialize-totp *ngIf="showTOTPInitializationDialog" [ngClass]="{'embedded': embeddedLogin}"
					(close)="showTOTPInitializationDialog=false; clearCredentials();"
					(codeVerified)="showTOTPInitializationDialog=false; codeVerified($event)"
					(sessionExpired)="showSessionExpiredMessage=true">
</cp-initialize-totp>

<cp-info-popup *ngIf="showSessionExpiredMessage" [ngClass]="{'embedded': embeddedLogin}"
				(close)="showSessionExpiredMessage=false;showVerificationCodeDialog=false;showTOTPInitializationDialog=false;clearCredentials();">
	<div class="popup-text">{{'SessionIsExpired' | cpMessageTranslate}}</div>
	<cp-popup-buttons-ok class="popup-buttons" 
						(ok)="showSessionExpiredMessage=false;showVerificationCodeDialog=false;showTOTPInitializationDialog=false;clearCredentials();">
	</cp-popup-buttons-ok>
</cp-info-popup>